import FormSelect from 'components/Select/FormSelect';
import { TCreateGameSelectedItem } from 'modules/Entertainment/Games/CreateGame/createGameState/createGameContext';
import React, { useEffect } from 'react';
import { IItemForGetShortInfo, IGetSubCategoriesShort } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getSubCategoriesShortInfo } from 'backend/subcategories';

interface IDishModificationSubCategorySelect {
	setDishModificationSubCategory: (value: TCreateGameSelectedItem) => void;
	setFetchedDishModificationSubCategories: (value: IItemForGetShortInfo[]) => void;
	selectedDishModificationCategory: Nullable<string>;
}

const DishModificationSubCategorySelect: React.FC<IDishModificationSubCategorySelect> = ({
	selectedDishModificationCategory,
	setFetchedDishModificationSubCategories,
	setDishModificationSubCategory,
}) => {
	const { response, loading, refetch, responseError } = useFetchData<IGetSubCategoriesShort, string[]>(
		selectedDishModificationCategory ? getSubCategoriesShortInfo : null,
		selectedDishModificationCategory ? [selectedDishModificationCategory] : [],
	);

	useEffect(() => {
		refetch();
	}, [selectedDishModificationCategory]);

	useEffect(() => {
		response && setFetchedDishModificationSubCategories(response.data.subCategories);
	}, [response]);

	return (
		<FormSelect
			name="selectedDishModificationSubCategory"
			label="subcategoryLabel"
			options={response?.data.subCategories}
			fetchError={responseError}
			loading={loading}
			onRefetch={refetch}
			disabled={!selectedDishModificationCategory || loading}
			onChange={setDishModificationSubCategory}
		/>
	);
};

export default React.memo(DishModificationSubCategorySelect);
